import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'open_with_faire-pdp_payment_terms_learn_more-click';
/**
 * Click event when user clicks the learn more button (regarding payment terms) on the product details page
 */
export function trackOpenWithFairePdpPaymentTermsLearnMoreClick(pageName = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { pageName },
    });
}
